import store from "@store/index"
import _ from "lodash"
import Vue from 'vue'

// state
const state = {
    form: {},
    sections: {},
    rows: {},
    answers: {},
    settings: {},
    stop: {
        section: null,
        row: null
    }
}

// getters
const getters = {

    matchCondition: (state) => (condition) => {

        var row = condition.form_row ? condition.form_row : {}
        var answer = _.get(state.answers, row.key)

        var operator = condition.condition_operator
        var value = condition.condition_value
        

        if(row.type == 'place')
        {
            answer = _.get(answer, 'address', null);
        }

        // Clean answer from empty values
        answer = _.isArray(answer) ? _.filter(answer) : answer;


        if(condition.exact_match)
        {  
            answer = _.isArray(answer)
            ? _.map(answer, item => {
                return _.kebabCase(item)
            }) : _.kebabCase(answer)

            value = _.map(value, v => {
                return _.kebabCase(v)
            })
        }
        

        switch(operator)
        {
            case "=":
                return _.isArray(answer) 
                ? _.intersection(answer, value).length == value.length
                && value.length == answer.length
                : answer == value[0];
                break;

            case "!=":
                return _.isArray(answer) 
                ? _.intersection(answer, value).length == 0
                : answer != value[0];
                break;

            case "in":
                return _.isArray(answer)
                ? _.intersection(answer, value).length
                : value.includes(answer)
                break;
        }

    },

    matchConditions: (state, getters) => (item) => {

        if(!item) {
            return false;
        }

        var groups = _.groupBy(item.conditions, 'group')
        var visible = false

        if(!_.keys(groups).length)
        {
            return true
        }

        _.forEach(groups, (group, i) => {

            var has_group = false;
            var check = [];

            group.forEach(condition => {
                check.push(getters.matchCondition(condition) ? 1 : 0)
            })

            if(_.sum(check) == check.length) 
            {
                visible = true;
                return false;
            }


        })

        if(item.id == 6)
        {
            console.log(getters.matchCondition(
                groups['68e86f7a-84a8-48ae-b5a8-dc03b8cb84b1a'][0]
            ))
        }

        // Visible and not set as stop yet ? Then set it to stop
        if(visible && _.get(item, 'type') == 'stop' && !state.stop.row)
        {
            store.dispatch('form/setStop', {
                row: item.id,
                section: item.parentable_type == 'formSection' ? item.parentable_id : null
            })
        }

        return visible

    },

    isVisible: (state, getters) => (item) => {

        var visible = getters.matchConditions(item)

        if(!item) {
            return false;
        }

        // Is it a row ?
        if(item.type) {

            if(!visible && state.answers[item.key])
            {
                //store.dispatch('form/unsetAnswer', item.key)
            }

            var index = _.findIndex(state.rows, o => {
                return o.id == item.id; 
            })

            return state.stop.row 
            ? visible && index <= state.stop.row
            : visible
        }

        // Is it a section ?
        if(!item.type) {

            var index = _.findIndex(state.sections, o => {
                return o.id == item.id; 
            })

            if(!visible)
            {
                _.map(item.rows, row => {
                    if(state.answers[row.key])
                    {
                        //store.dispatch('form/unsetAnswer', row.key)
                    }
                })
            }

            return state.stop.section 
            ? visible && index <= state.stop.section
            : visible

        }

    },

    countProgress(state, getters) {

    },

    answers(state, getters) {
        return _.mapValues(state.answers, (answer, key) => {

            var row = _.find(state.rows, row => {
                return row.key == key && getters.isVisible(row)
            })

            if(['checkbox', 'select', 'radio'].includes(row.type))
            {
                var answer = App.$trans(row.value)[answer]
                return _.get(answer, 'name', answer)
            }
            
            return answer

        })
    },

    rows(state, getters) {
        return _.filter(state.rows, row => {
            return row.parentable_type == 'form'
            && getters.isVisible(row)
        })
    },
    
    sections(state, getters) {
        return _.filter(state.sections, section => {
            return section.parentable_type == 'form'
            && getters.isVisible(section)
        })
    },

    stop(state) {
        return state.stop.row ? true : false
    },

    progress(state, getters) {

        var sections = {}

        _.map(getters.sections, section => {

            var count = 0;
            var total = 0;

            var rows = _.filter(state.rows, row => {
                return row.parentable_type == 'formSection' 
                && row.parentable_id == section.id
            })

            _.map(rows, row => {

                if(getters.isVisible(row))
                {
                    var answer = getters.answers[row.key]

                    if(answer) {

                        if(_.isArray(answer)) {
                            if(answer.length) {
                                count += 1
                            }
                        } else {
                            count += 1
                        }

                    }

                    total += 1
                }

            })

            sections[section.id] = {
                count: count,
                total: total,
                percentage: Math.ceil(count * 100 / total)
            }

        })

        var count = _.sum(_.map(sections, 'count'))
        var total = _.sum(_.map(sections, 'total'))

        return {
            count: count,
            total: total,
            percentage: Math.ceil(count * 100 / total),
            sections: sections
        }

    }

}

// actions
const actions = {

    initForm({commit, dispatch}, id) {

        return new Promise((resolve, reject) => {
            
            axios.post('/forms/'+id)
            .then(response => {                        
                commit('setForm', response.data.form)
                commit('setSettings', response.data.form.settings)
                commit('setSections', response.data.sections)
                commit('setRows', response.data.rows)
                commit('setAnswers', Object.fromEntries(response.data.answers))
                dispatch('setDefaultAnswers')

                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })

        })

    },

    submitForm() {
        return new Promise((resolve, reject) => {

            setTimeout(() => {
                this._vm.$flash("Form submitted")
                resolve()
            }, 1000);

        })
    },

    setDefaultAnswers({state, commit}) {

        _.map(state.rows, row => {

            if(row.default_value)
            {
                var value = this._vm.$trans(row.default_value)

                commit('setAnswer', {
                    key: row.key,
                    value: value
                })
            }

        })
        
    },

    setStop({state, commit}, payload) {

        var indexRow = _.findIndex(state.rows, o => {
            return o.id == payload.row; 
        });

        var indexSection = _.findIndex(state.sections, o => {
            return o.id == payload.section; 
        });

        commit('setStopRow', indexRow > 0 ? indexRow : 0)
        commit('setStopSection', indexSection > 0 ? indexSection : 0)
    },


    resetStop({dispatch}) {
        dispatch('setStop', {
            row: null,
            section: null
        })
    },


    unsetAnswer({commit, dispatch, state}, key) {
        
        if(state.answers[key]) 
        {
            delete state.answers[key]
            dispatch('resetStop')
        }
    },

    setAnswer({commit, dispatch}, payload) {
        dispatch('resetStop')
        commit('setAnswer', payload)
    }

}
 
// mutations
const mutations = {

    setForm(state, value) {
        state.form = value
    },

    setSections(state, value) {
        state.sections = value
    },
    
    setRows(state, value) {
        state.rows = value
    },

    setAnswer(state, payload) {
        Vue.set(state.answers, payload.key, payload.value)
    },

    setAnswers(state, value) {
        state.answers = value
    },

    setSettings(state, value) {
        state.settings = value
    },

    setProgress(state, value) {
        state.progress = value
    },

    setStopRow(state, value) {
        state.stop.row = value
    },

    setStopSection(state, value) {
        state.stop.section = value
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}